<template>
	<b-col lg="12">
		<b-card no-body>
			<b-card-header>
				<h4 class="mb-0">
					Notes
				</h4>
			</b-card-header>

			<b-row class="mx-0">
				<b-col cols="12" class="border-top d-flex align-items-between flex-column py-1">
					<b-card>
						<b-card-text>
							<strong>How "Generate - Site Image" works:</strong> Select the site first, then click on the "Generate image" button or upload a file from your computer. Click on the "Preview image" button to see a preview of the screenshot.
						</b-card-text>
						<b-card-text class="text-danger">
							<strong>Note:</strong> If you face a caching issue, then you will need to upload the image from your computer.
						</b-card-text>
					</b-card>
				</b-col>
			</b-row>
		</b-card>
	</b-col>
</template>

<script>
	import {
		BCard, BCardHeader, BRow, BCol, BCardText,
	} from 'bootstrap-vue'

	export default {
		components: {
			BCard, BCardHeader, BRow, BCol, BCardText,
		},
	}
</script>